import { UpdatePartnerContactRequestSchema, UpdatePartnerContactResponseSchema } from './update-partner-contact.schema';
export const updatePartnerContactContract = {
    method: 'PATCH',
    path: '/api/v2/partner/contacts/:id',
    description: "Edit or check off a contact on the caller's partner call list",
    requestSchema: UpdatePartnerContactRequestSchema,
    responseSchema: UpdatePartnerContactResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Bad Request - invalid input data',
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - not a partner tenant member',
            404: "Contact not found on the caller's list"
        }
    }
};

//# sourceMappingURL=update-partner-contact.contract.js.map